import { FC } from 'react'
import { InputTextType } from '../../../common/InputType'

type Props = {
  first: InputTextType
  second: InputTextType
}

const TowInputText: FC<Props> = (props) => {
  const { first, second } = props

  return (
    <div className="switcher">
      <span>
        <label htmlFor={first.id} className="d-block">
          {first.icon && <first.icon className="me-1" />}
          {first.label && `${first.label}:`}
          {first.required && (
            <span className="text-light bg-danger badge ms-1">必須</span>
          )}
        </label>
        <input
          type={first.type}
          id={first.id}
          placeholder={first.placeholder}
          autoComplete={first.autoComplete}
          style={{ width: '100%' }}
          value={first.state}
          readOnly={first.readonly}
          maxLength={first.maxLength}
          onChange={(e) => first.setState(e.target.value)}
        />
      </span>
      <span>
        <label htmlFor={second.id} className="d-block">
          {second.icon && <second.icon className="me-1" />}
          {second.label && `${second.label}:`}
          {second.required && (
            <span className="text-light bg-danger badge ms-1">必須</span>
          )}
        </label>
        <input
          type={second.type}
          id={second.id}
          placeholder={second.placeholder}
          autoComplete={second.autoComplete}
          style={{ width: '100%' }}
          value={second.state}
          readOnly={second.readonly}
          maxLength={second.maxLength}
          onChange={(e) => second.setState(e.target.value)}
        />
      </span>
      <span></span>
    </div>
  )
}

export default TowInputText
